export default ($window, $timeout) => ({
  restrict: "AC",
  scope: false,
  link($scope, $elem, $attr) {
    if (!$window.MagicScroll) return;
    const doRefresh = () => $window.MagicScroll.start($elem[0]);
    const refresh = () => {
      $window.MagicScroll.stop($elem[0]);
      $timeout(doRefresh, 1000);
    };
    $elem.addClass("MagicScroll");
    refresh();
    $attr.$observe("href", (href) => refresh(href));
    $scope.$on("$destroy", () => {
      // console.debug("MagicScroll.destroy", $elem[0]);
      $window.MagicScroll.stop($elem[0]);
      // console.warn("MagicScroll.stop", $elem[0]);
    });
  },
});
